import { selfAxios } from "@oppein/op-utils";
/**
 * 保存取号标签
 */
export async function saveByOrgPermissions(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerMainContactLabel/saveByOrgPermissions",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/customerMainContactLabel/saveByOrgPermissions/post.js